export enum NavItemsEnum {
  INVEST = 'Invest',
  MANAGE = 'Manage'
}